import React from "react";
import useAdminListBlogs from "../hooks/useAdminListBlogs";
import AdminListBlogs from "../components/AdminListBlogs";

const { handleDelete = null } = useAdminListBlogs;

export default function AdminListBlogsInterface(props) {
  const { onEdit, onSave, businessType, onEdit2 } = props;

  return (
    <React.Fragment>
      <AdminListBlogs
        onSave={onSave}
        handleDelete={handleDelete}
        onEdit={onEdit}
        businessType={businessType}
        onEdit2={onEdit2}
      />
    </React.Fragment>
  );
}
